import { Button, ButtonProps } from '@arco-design/web-react';
import React from 'react';

export function ButtonEdit({ text = '编辑', ...rest }: ButtonProps & { text?: string }) {
  return (
    <Button type="primary" size="small" {...rest}>
      {text}
    </Button>
  );
}
